import { RobotEntityModel } from "src/store/models/entity/robot/entity";
import { RobotHelperModel } from "src/store/models/entity/robot/helper";

export const encooRobotModels = {
  entity: RobotEntityModel,
  helper: RobotHelperModel,
};
